document.addEventListener( 'DOMContentLoaded', function () {
	var toggle = document.querySelector( '.nav__toggle' );
	var links = document.querySelector( '.nav__links' );

	if ( ! toggle || ! links ) {
		return;
	}

	toggle.addEventListener( 'click', function () {
		var isOpen = links.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	} );

	links.querySelectorAll( 'a' ).forEach( function ( link ) {
		link.addEventListener( 'click', function () {
			links.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
		} );
	} );
} );
